import api from 'Application/api/api';

const passwordConfirmSuccessfulCheckForDirectProcedure = (
    driverLicenseControlId,
    password,
    cancelToken = null,
) =>
    api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/direct-check/password-confirm-successful-check`,
        {
            password,
        },
        {
            cancelToken,
        },
    );

export default passwordConfirmSuccessfulCheckForDirectProcedure;
